import type { ReactNode } from 'react';

import { SheetHeader } from '~/components/ui';
import type { PackResponseDto } from '~/lib/api';
import { usePacksControllerGetPackPossibleDrops } from '~/lib/api';
import { PossibleDropFromUnwrapCard } from '../collection-card/possible-drop-from-unwrap-card';
import { MintIndicator } from '~/module/mint/mint-indicator';

interface WrappedPackSheetContentProps {
  pack: PackResponseDto;
  bottomContent?: ReactNode;
}

export const WrappedPackSheetContent = ({ pack, bottomContent }: WrappedPackSheetContentProps) => {
  const possibleDrops = usePacksControllerGetPackPossibleDrops(pack.id);
  const isMinted = pack.nft?.nftMintStatus === 'DONE';

  return (
    <div className="h-full flex flex-col">
      <SheetHeader className="font-bold mt-[100px] text-center w-full mb-8 text-3xl items-center">
        <div className="flex items-center gap-2">
          {isMinted ? <MintIndicator /> : null}
          <div>{pack.name}</div>
        </div>
      </SheetHeader>

      <div className="grid gap-2 grid-cols-2 overflow-y-auto flex-1 auto-rows-min pb-50">
        {possibleDrops.data?.data.collections.map((collection) => (
          <PossibleDropFromUnwrapCard
            key={collection.collectionId}
            brandName={collection.brandName}
            dropChance={Math.floor(100 * collection.dropChance)}
            id={collection.collectionId}
            imagePosition={collection.collectionImagePosition}
            imageSrc={collection.collectionImageUrl as unknown as string}
            label={collection.totalSupply}
            rarity={collection.rarity}
            title={collection.collectionName}
          />
        ))}
      </div>

      {(possibleDrops.data?.data.collections.length ?? 0) > 0 && bottomContent ? (
        <div className="fixed bottom-0 left-0 right-0 w-full p-4 z-[500] bg-black">{bottomContent}</div>
      ) : null}
    </div>
  );
};
